/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { FlexCol, Select } from 'sarsaparilla';
import PropTypes from 'prop-types';

export default function OptionSelectForm(props) {
    const { options, selectedOptions, reservationPosition, submitAttempted, onChange } =
        props;
    if (!options) {
        return null;
    }
    let selectedMap = {};
    if (selectedOptions) {
        selectedMap = selectedOptions.reduce(
            (result, item) => ({ ...result, [item.type]: item.value }),
            {}
        );
    }

    const handleChange = (type, e) => {
        const requiredOptions = options.filter((opt) => opt.is_required);
        const isValid = requiredOptions.reduce(
            (acc, cur) =>
                acc &&
                (cur.type === type ||
                    (!!selectedMap[cur.type] && selectedMap[cur.type] !== '')),
            true
        );
        onChange({ type, value: e.target.value }, isValid);
    };

    return (
        <>
            {options.map((selection) => {
                return (
                    <FlexCol lg={6} key={selection.type}>
                        <div className="rec-form-item-wrap">
                            <Select
                                id={`option-select-${selection.type}-${reservationPosition}`}
                                label={selection.label}
                                isRequired={
                                    props?.skipCustomerInfo
                                        ? false
                                        : selection.is_required
                                }
                                placeholder={selection.label}
                                isDisabled={props?.skipCustomerInfo}
                                isInvalid={
                                    props?.skipCustomerInfo
                                        ? false
                                        : submitAttempted &&
                                          selection.is_required &&
                                          !selectedMap[selection.type]
                                }
                                options={selection.values}
                                defaultValue=""
                                value={
                                    props?.skipCustomerInfo
                                        ? ''
                                        : selectedMap[selection.type] || ''
                                }
                                onChange={(e) => handleChange(selection.type, e)}
                            />
                        </div>
                    </FlexCol>
                );
            })}
        </>
    );
}

OptionSelectForm.propTypes = {
    options: PropTypes.any,
    selectedOptions: PropTypes.any,
    reservationPosition: PropTypes.any,
    submitAttempted: PropTypes.bool,
    onChange: PropTypes.func,
};
